<template>
  <div class="sf-commcard sf-commcard-checks sf-below-3" type="checklist">
    <div class="sf-commcard-title sf-uppercase">{{ checkListName }}</div>
    <div>
      <CheckCard v-bind="$attrs"></CheckCard>
    </div>
  </div>
</template>

<script>
import CheckCard from './check-card'

export default {
  components: {
    CheckCard,
  },
  props: {
    checkListName: {
      type: String,
      required: true,
    },
  },
}
</script>
